import { ref } from "vue";

const appHeight = ref(0);

export function useAppHeight() {
  return appHeight;
}

